export default class StructureOptionsItem {
  static FIND_SIMILAR = 'FIND_SIMILAR';

  static VIEW_RELATED_MARKUSH = 'VIEW_RELATED_MARKUSH';

  static VIEW_DETAILS = 'VIEW_DETAILS';

  static COPY_STRUCTURE_TO_QUERY = 'COPY_STRUCTURE_TO_QUERY';

  static COPY_REACTION_TO_QUERY = 'COPY_REACTION_TO_QUERY';

  static COPY_SMILES = 'COPY_SMILES';

  static USE_AS_FILTER = 'USE_AS_FILTER';

  static GET_ALL_RELATED_SUBSTANCES = 'GET_ALL_RELATED_SUBSTANCES';

  static OPEN_IN_DATABASE = 'OPEN_IN_DATABASE';

  static SYNTHESIS_OPTIONS = 'SYNTHESIS_OPTIONS';

  static get all() {
    return [
      this.FIND_SIMILAR,
      this.VIEW_RELATED_MARKUSH,
      this.VIEW_DETAILS,
      this.COPY_STRUCTURE_TO_QUERY,
      this.COPY_REACTION_TO_QUERY,
      this.COPY_SMILES,
      this.USE_AS_FILTER,
      this.GET_ALL_RELATED_SUBSTANCES,
      this.OPEN_IN_DATABASE,
      this.SYNTHESIS_OPTIONS,
    ];
  }
}
